module.exports = __webpack_public_path__ + "img/Jump Casting18.da681e6a.jpg";